// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".photo-wrapper[data-v-6831e5bc]{position:relative}.photo-wrapper:hover .photo[data-v-6831e5bc]{opacity:.7}.photo-wrapper:hover .photo-overlay[data-v-6831e5bc]{display:flex}.photo[data-v-6831e5bc]{margin-right:20px;transition:opacity .3s}.photo-overlay[data-v-6831e5bc]{align-items:center;background-color:rgba(0,0,0,.678);border-radius:8px;display:none;height:100%;justify-content:center;left:0;position:absolute;top:0;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
